// Core Modules
import { Injectable } from '@angular/core';

// Models
import { IAuth0Configuration } from '@shared/models/auth0-types.model';
import { AppEndpointsModel } from '@shared/models/endpoints.config.model';

// Environment
import { environment } from '@env/environment';

// App Contents
import appContents from '@assets/app-contents.json';

/**
 * Config Service
 */
@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  // Private Members
  /**
   * Load all the app constants into a variables
   */
  private readonly contents: any = appContents;

  get auth0Domain(): string {
    return environment.AUTH0.domain;
  }

  get auth0Tenant(): string {
    return environment.AUTH0.tenant;
  }

  get encryptKey(): string {
    return environment.LOCAL_STORAGE_ENCRYPTION;
  }

  get getAPIBaseUrl(): string {
    return environment.API;
  }

  get getAuthConfig(): IAuth0Configuration {
    return environment.AUTH0;
  }

  get logoutNotifyExpiryTime(): number {
    return environment.SESSION.logoutNotifyExpiryTime;
  }

  get refreshSessionInterval(): number {
    return environment.SESSION.refreshSessionInterval;
  }

  /**
   * Get the app content by section name,
   * section name should be parent field from the app-contents.json file
   * @sectionName section name to return content
   * @returns content data by section name, e.g. sectionName=footer OR header
   */
  public getContents(sectionName: string): any {
    return this.contents[sectionName];
  }

  /**
   * Utility method to get the endpoints by module name
   * @param module Module name to get endpoints list
   * @returns Module wise endpoint list
   */
  public getEndpointsByModule(module: string): AppEndpointsModel {
    return this.contents.endpoints[module];
  }
}
